import { FC } from 'react'
import { Form } from 'react-bootstrap'
import { FieldProps } from '../Forms.d'
import { Calendar } from 'primereact/calendar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAsterisk } from '@fortawesome/free-solid-svg-icons'

const DateField: FC<FieldProps> = ({
    id,
    label = '',
    showLabel = true,
    name,
    formikProps,
    placeholder = '',
    groupClassName = '',
    className = '',
    required = false,
    disabled = false,
    readonly = false,
    onBlur,
}) => {
    const { values, errors, touched, handleChange } = formikProps

    return (
        <Form.Group
            className={
                (groupClassName || '') +
                ' sfy-field mb-3' +
                (required ? ' required' : '')
            }
            controlId={id}
        >
            {showLabel && (
                <Form.Label>
                    {label}{' '}
                    {required && (
                        <FontAwesomeIcon
                            icon={faAsterisk}
                            className="text-danger"
                            size="xs"
                        />
                    )}
                </Form.Label>
            )}
            <br />
            <Calendar
                name={name}
                value={values[name] ? new Date(values[name]) : null}
                onChange={handleChange}
                dateFormat="dd/mm/yy"
                onBlur={(e) => {
                    if (onBlur) onBlur(e)
                }}
                placeholder={placeholder}
                className={
                    'w-100 ' +
                    (className || '') +
                    ' ' +
                    (errors[name] && touched[name] ? 'is-invalid' : '') +
                    (readonly ? ' readonly' : '')
                }
                inputClassName="form-control"
                showButtonBar
                disabled={disabled}
            />
            <span className="bottom-border"></span>
            {errors[name] && touched[name] && (
                <Form.Text className="invalid-feedback">
                    {errors[name].toString()}
                </Form.Text>
            )}
        </Form.Group>
    )
}

export default DateField
